<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-settings"
      scrollable
      title="Configurações da Pasta"
      size="lg"
    >
      <div class="form-group row mb-4">
        <div class="col-md-12 pt-2">
          <label for="txtData"> Descrição:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite a descrição do novo item de menu'"
              v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state">
            </b-form-input>
          </div>
        </div>
        <div class="col-md-6 pt-3">
          <label for="txtData"> Seção:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o nome da Seção'"
              v-model="form.secaoNome.value"
              :size="form.secaoNome.maxlength"
              :required="form.secaoNome.required"
              :state="form.secaoNome.state"
              disabled>
            </b-form-input>
          </div>
        </div>
        <div class="col-md-6 pt-3">
          <label for="txtData"> Menu:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o nome do Menu'"
              v-model="form.menuNome.value"
              :size="form.menuNome.maxlength"
              :required="form.menuNome.required"
              :state="form.menuNome.state"
              disabled>
            </b-form-input>
          </div>
        </div>
        <div class="col-md-6 pt-3">
          <label for="txtData"> Proprietário:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o nome do proprietário'"
              v-model="form.dono.value"
              :size="form.dono.maxlength"
              :required="form.dono.required"
              :state="form.dono.state"
              disabled>
            </b-form-input>
          </div>
        </div>
        <div class="col-md-6 pt-2">
          <div class="col-md-12 pl-3" style="margin-top: 38px;">
            <b-form-checkbox v-model="form.publico.value" :required="form.publico.required" :state="form.publico.state" switch>
              <template slot="default">Tornar público</template>
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="row col-12 pb-3">
          <div class="col-6 text-left" style="padding: 0">
            <button type="button" class="btn btn-danger btn-sm"  v-b-tooltip.hover :title="'Excluir'" @click.prevent="onDelete" :disabled="hasDataGed"><i class="fas fa-times-circle"></i><span class="d-md-down-none"> Excluir</span></button>
          </div>
          <div class="col-6 text-right">
            <button type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="'Salvar'" @click.prevent="onUpdate"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span></button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import GedMenuRepository from '@/shared/http/repositories/ged/gedmenu.js'

const menuForm = {
  nome: {
    value: '',
    maxlength: 100,
    required: true,
    state: null
  },
  publico: {
    value: false,
    required: false,
    state: null
  },
  dono: {
    value: '',
    maxlength: 100,
    required: true,
    state: null
  },
  secaoNome: {
    value: '',
    maxlength: 100,
    required: false,
    state: null
  },
  menuNome: {
    value: '',
    maxlength: 100,
    required: false,
    state: null
  }
}
const menuModel = {
  id: null,
  secaoId: null,
  menuId: null,
  nivel: 0,
  nome: null,
  publico: false,
  dono: null,
  tags: null
}

export default {
  name: 'ModalSharing',
  mixins: [ActionsForm],
  data () {
    return {
      data: menuModel,
      form: menuForm,
      menu: null,
      obj: null,
      gedDataLenght: 0
    }
  },
  computed: {
    hasDataGed () {
      let result = false
      if (this.gedDataLenght > 0) {
        result = true
      }
      return result
    }
  },
  methods: {
    showModal (obj, count) {
      this.onClear()
      this.$refs['modal-settings'].show()
      this.gedDataLenght = count
      this.onEdit(obj)
    },
    hideModal () {
      this.$refs['modal-settings'].hide()
    },
    onEdit (obj) {
      this.menu = obj
      this.form.nome.value = obj.nome
      this.form.publico.value = obj.publico
      this.form.secaoNome.value = obj.secao ? obj.secao.nome : ''
      this.form.menuNome.value = (obj.path && obj.path.length > 0) ? obj.path.join(' / ') : ''

      if (obj.donoNome) {
        this.form.dono.value = obj.donoNome
      } else {
        loading.push()
        GedMenuRepository.GetById(obj.id)
          .then((response) => {
            loading.close()
            this.obj = response.data
            this.form.dono.value = response.data.donoNome.replace('\t', '')
          })
          .catch(this.onException)
      }
    },
    onUpdate () {
      this.data = this.obj
      this.data.nome = this.form.nome.value
      this.data.publico = !!this.form.publico.value

      loading.push()
      GedMenuRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.hideModal()
          toast.success(this.$lang.Common.Alerts.Success, 'MENU')
          this.$emit('ReloadMenu', this.data)
        })
        .catch(this.onException)
    },
    onDelete () {
      loading.push()
      if (this.menu.id) {
        GedMenuRepository.Delete(this.menu.id)
          .then((response) => {
            loading.close()
            this.hideModal()
            toast.success('Exclusao do menu ' + this.menu.nome + ' realizado com sucesso!', 'MENU - EXCLUSÃO')
            this.$emit('ReloadMenu', this.data)
          })
          .catch(this.onException)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/rightcontent/components/modalsettings.vue